import React from 'react';
import PropTypes from 'prop-types';
import {
  FDIcon, FDStack, FDTitleText,
} from '@facet-wealth/design';
import Relationship from 'facet-rest/src/domain/Relationship';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import { dataAttrs } from 'Helpers/Testing';

// This uses chip to match the AddReactionButton, which was created before FD
export const RouteMessageButton = ({ relationship }) => {
  const { loadModalCollectionByLink } = useModalContext();
  const isDisabled = relationship.meta('disabled');

  return (
    <Chip
      size="small"
      variant="outlined"
      disabled={isDisabled}
      label={
        <FDStack spacing={1} direction={'row'} alignItems={'center'} paddingX={0.5} paddingY={0.5}>
          <FDIcon icon={relationship.meta('icon')} size={'sm'} color={isDisabled ? 'textDisabled' : 'textPrimary'} />
          <FDTitleText value={relationship.meta('prompt')} size={'sm'} color={isDisabled ? 'textDisabled' : 'textPrimary'} />
        </FDStack>
        }
      onClick={() => loadModalCollectionByLink(relationship.link('related').url())}
      {...dataAttrs('manually-route-message-button')}
    />
  );
};

RouteMessageButton.defaultProps = {
};

RouteMessageButton.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
};
